import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'

import {
  initCurrentUserStateMiddleware,
  checkAccessMiddleware,
  checkAbility,
  checkPublicRouteMiddleware,
} from './middlewares'
import { routes } from './routes'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(Router)
Vue.use(VueMeta, {
  keyName: 'page',
})

const router = new Router({
  linkActiveClass: 'link-active-class',
  linkExactActiveClass: 'link-exact-active-class',
  mode: 'hash',
  routes,

  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0,
      }
    }
  },
})

router.beforeEach(initCurrentUserStateMiddleware)
router.beforeEach(checkAccessMiddleware)
router.beforeEach(checkAbility)
router.beforeEach(checkPublicRouteMiddleware)

export default router
